import React from 'react';
import TopBanner from '../MainContents/TopBanner';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop';  
import CourseTable from './CourseTable.jsx'; 
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = styled.button`
    border: 2px solid  #990820;
    background: #fdfdfd;
    padding: 10px;
    margin-left: 10px;
    font-weight: bold;
`;
const Pointer = styled.span`
    color: #fff;
    display: inline-block;
    background:  linear-gradient(0deg, #990820 0%, #ba0020 100%);
    width: 25px;
    height: 25px;
    border-radius: 50%;
`;
const url = '/yotsutaninet/';
class Course extends React.Component {
    render() {
        return (
            <>
                <ScrollToTopOnMount />
                <TopBanner  title="コース/時間割" 
                            text1="令和6年度 土佐塾・はりまやYT教室　前期時間割(3月～7月)" 
                            text2="※平日の補習や土曜日の個別指導は、無料となっています。" 
                            text3="※授業前の自主学習用教室として、新館2-1、新館2-2、新館3-1を開放しますので、ぜひ利用してください。" 
                            text4="※通塾の困難な生徒は、Zoomでの授業参加も可能です。" 
                />

                            {/* <div className="text-center mt-5">
                                <Link  to={url + 'Winter'} >
                                    <Button >冬期講座の時間割はこちら<Pointer>→</Pointer></Button>
                                </Link>
                            </div> */}
                {/* 小学3年生  YTクラス */}
                <CourseTable 
                    id="1"
                    heading="小学３年生 新館2-1"
                    detailComment="※　土佐塾模試の日は、13:50～14:35の時間帯は算数になります。"
                    detailComment2="※　木曜日・土曜日の個別指導、特訓は、都合によりお休みになる場合があります。予めご了承ください。"
                />

                {/* 小学3年生  YT土曜クラス */}
                <CourseTable 
                    id="2"
                    heading="小学４年⽣ 新館3-1"
                    detailComment="木曜日・土曜日の個別指導、特訓は、都合によりお休みになる場合があります。予めご了承ください。"

                />

                {/* 小学4年生  TSクラス */}
                <CourseTable 
                    id="3"
                    heading="新小学５年生 新館2-1教室 "
                    detailComment="木曜日・土曜日の個別指導、特訓は、都合によりお休みになる場合があります。予めご了承ください。"
                />

                {/* 小学4年生  YTクラス */}
                <CourseTable 
                    id="4"
                    heading="小学６年生 新館2-1"
                    detailComment="土曜日の個別指導、都合によりお休みになる場合があります。予めご了承ください。"
                />


            </>
        );
      }
}

export default Course;